import { z } from "zod";

export const salesListSortEnum = z.enum(["newest", "oldest"]);
export const sellerListSortEnum = z.enum(["newest", "oldest"]);
export const buyerListSortEnum = z.enum(["newest", "oldest"]);
export const verificationStatusEnum = z.enum(["pending", "rejected"]);

export type SalesListSortValue = z.infer<typeof salesListSortEnum>;
export type SellerListSortValue = z.infer<typeof sellerListSortEnum>;
export type BuyerListSortValue = z.infer<typeof buyerListSortEnum>;
export type VerificationStatus = z.infer<typeof verificationStatusEnum>;

export type SalesListItem = {
  id: string;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  enabled: boolean;
  role_name: "sales";
  attributes: {
    employee_id: string;
    initials: string;
    lintas_customer_id: string;
    referral_id: string;
    user_signup_type: string;
  };
  media_path: string;
  created_at: string; // ISO date string
};

export type Attributes = {
  user_type: string;
  npwp: string;
  npwp_file: string;
  npwp_number: string;
  nib: string;
  nib_file: string;
  nib_number: string;
  company_name: string;
  country: string;
  city: string;
  sales_referral_id: string;
  referral_id: string;
  lintas_customer_id?: string;
  company_type: string;
  company_address: string;
  building_name: string;
  floor: string;
  postal_code: string;
  verification_status?: VerificationStatus;
};

export type BuyerItem = {
  id: string;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  enabled: boolean;
  role_name: string;
  attributes: Attributes;
  created_at: string;
};

export type BuyerDetail = BuyerItem & {
  media_path: string;
};

export type SellerListItem = {
  id: string;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  enabled: boolean;
  role_name: string;
  attributes: {
    company_name?: string;
    npwp_number?: string;
    show_checkout_step_walkthrough?: string;
    show_product_detail_walkthrough?: string;
    status?: string;
    seller_type: SellerType;
  };
  media_path: string;
  created_at: string;
};

export type PicSalesItem = {
  sales_pic_employee_no: string;
  sales_pic_name: string;
};

export type SellerType = "internal" | "external";
